export default __webpack_public_path__ + "static/media/time.b05c9dc5.svg";